<template>
<div>
    <div class="duration-container">
        <div class="duration-option"
            v-for="(block, index) in activeReservation.availableBlocks"
            :key="block.blockId"
            :class="{ 
                'bg-primary': activeReservation.selectedDuration === block.duration,
                'disabled': disabledBlockDuration(block),
                'hidden': index >= availableBlocks
            }"
            @click="selectDuration(index)">
            <p>{{ durationToString(block.duration) }}</p>
            <p>{{ $_formatCurrency(block.price * activeReservation.orderQuantity) }} {{ $_CURRENCY_SYMBOL }}</p>
        </div>
    </div>
    <div v-for="(resObj, index) in additionalReservations" :key="index">
        <h4>
            {{ resObj.block.resource.resourceName }}
            <button class="btn btn-xs btn-danger"
                    @click="toggleAdditionalBlock(index, false)">
                <i class="glyphicon glyphicon-trash"></i>
            </button>
        </h4>
        <div class="duration-container">
            <div class="duration-option"
                v-for="(block, index) in resObj.availableBlocks"
                :key="block.blockId"
                :class="{ 
                    'bg-primary': resObj.selectedDuration === block.duration,
                    'disabled': disabledBlockDuration(block),
                    'hidden': index >= availableBlocks
                }"
                @click="selectDuration(index)">
                <p>{{ durationToString(block.duration) }}</p>
                <p>{{ $_formatCurrency(block.price) }} {{ $_CURRENCY_SYMBOL }}</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    emits: ['selectDuration', 'toggleAdditionalBlock'],
    props: {
        additionalReservations: {
            type: Array,
            required: false,
            default: () => ([]),
        },
    },
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            activeReservation: 'calendar/activeReservation',
        }),
        disabledBlockDuration() {
            const adminMode = this.adminMode;
            const { 
                soldReservationTimeId,
                minDuration
            } = this.activeReservation;
            
            return (block) => {
                const { 
                    duration, 
                    selectDisabled 
                } = block;
                
                if (adminMode) {
                    return soldReservationTimeId && selectDisabled;
                }

                return minDuration > duration || selectDisabled;
            }
        },
        availableBlocks() {
            return [
                ...this.additionalReservations,
                this.activeReservation
            ].reduce(
                (acc, curr) => curr.availableBlocks.length < acc ? curr.availableBlocks.length : acc, 
                this.activeReservation.availableBlocks.length
            )
        },
        durationToString() {
            return (minutes) => {
                if (minutes < 60) {
                    return `${ minutes }min`
                }
                let readable = `${ Math.floor(minutes / 60) }h`;
                
                const scraps = minutes % 60;

                if (scraps > 0) {
                    readable += ` ${ scraps }min`;
                }
                
                return readable;
            }
        },
    },
    methods: {
        selectDuration(index) {
            this.$emit('selectDuration', { index })
        },
        toggleAdditionalBlock(index, add) {
            this.$emit('toggleAdditionalBlock', { index, add })
        },
    },
}
</script>

<style scoped>
.duration-container {
    display: flex;
    position:relative;
    overflow-x: auto;
    margin-bottom: 17px;
}
</style>